// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__BdPun","horizontal":"styles_horizontal__JWO9t","vertical":"styles_vertical__6vkzM","slideInSearchBar":"styles_slideInSearchBar__9YP_Y"};